// Subscribe collection dynamic pricing via API
(function() {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('discount');

  if (!code) return;

  // Append discount code to all product links on the page
  document.querySelectorAll('a[href*="/products/"]').forEach(link => {
    const url = new URL(link.href);
    if (!url.searchParams.has('discount')) {
      url.searchParams.set('discount', code);
      link.href = url.toString();
    }
  });

  // Apply discount to existing cart using Shopify's 2025 Cart API
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ discount: code })
  }).then(r => r.json()).then(cart => {
    console.log('Discount applied:', code, cart);
  }).catch(e => console.error('Discount apply failed:', e));

  fetch(`https://www.creem.com/api/discount-info?code=${encodeURIComponent(code)}`)
    .then(r => r.json())
    .then(data => {
      if (!data.exists || !data.valueType) return;

      document.querySelectorAll('.price').forEach(priceContainer => {
        const priceRegular = priceContainer.querySelector('.price__regular .price-item--regular');
        const priceSale = priceContainer.querySelector('.price__sale');

        if (!priceRegular || !priceSale) return;

        const priceText = priceRegular.textContent.trim();
        const priceMatch = priceText.match(/[\d,]+\.?\d*/);
        if (!priceMatch) return;

        const originalPrice = parseFloat(priceMatch[0].replace(',', ''));
        if (isNaN(originalPrice)) return;

        // Calculate discount based on type
        let discountedPrice;
        if (data.valueType === 'percentage') {
          // Use absolute value to ensure we're always reducing the price
          const discountPercent = Math.abs(data.value);
          discountedPrice = originalPrice * ((100 - discountPercent) / 100);
        } else if (data.valueType === 'fixed_amount') {
          discountedPrice = Math.max(0, originalPrice - Math.abs(data.value));
        } else {
          return; // Unknown discount type
        }

        const currencySymbol = priceText.match(/[^\d\s,\.]+/)?.[0] || '$';
        const currencyCode = priceText.match(/ [A-Z]{3}/)?.[0] || '';
        const formattedPrice = `${currencySymbol}${discountedPrice.toFixed(2)}${currencyCode}`;

        priceContainer.classList.add('price--on-sale');
        priceSale.querySelector('.price-item--regular').textContent = priceText;
        priceSale.querySelector('.price-item--sale').textContent = formattedPrice;
        priceContainer.querySelector('.price__regular').style.display = 'none';
      });
    })
    .catch(() => {}); // Silently fail
})();
